import { Column, ModelBase } from 'loca-boot-core'
import { ResourceItemModel } from '../iconRender/icon.model'
import { LocationModel } from '../../models/location.model'

export class RouteDetailDataModel extends ModelBase {
  /**
   * 加电资源列表
   */
  @Column({ name: 'resources', childType: ResourceItemModel, autowired: true })
  public resources?: ResourceItemModel[]
  /**
   * 加电线路
   */
  @Column({ name: 'polyline' })
  public polyline!: string[]

  /**
   * 加电线路资源点距上一个的距离
   */
  @Column({ name: 'distance' })
  public distance!: number[]

  @Column({ name: 'polyline_rgeo', childType: LocationModel, autowired: true })
  public polylineRgeo!: LocationModel[]
}

export class GaiaContentModel extends ModelBase {
  @Column()
  public content!: string
}

export class RouteDetailModel extends ModelBase {
  @Column({ name: 'route_name' })
  public name!: string

  @Column({ name: 'route_img' })
  public image!: string

  @Column({ name: 'tags' })
  public tags!: string[]

  @Column({ name: 'description' })
  public description!: string
}

export class RouteModelDetail extends ModelBase {
  @Column()
  public name!: string

  @Column({ name: 'route_id' })
  public id!: string

  @Column({ name: 'detail', childType: RouteDetailModel })
  public detail!: RouteDetailModel

  @Column({ name: 'gaia_strategy', childType: GaiaContentModel })
  public gaia!: GaiaContentModel

  @Column({ name: 'map_data', childType: RouteDetailDataModel })
  public mapData!: RouteDetailDataModel
}

export class RecommendRoutes extends ModelBase {
  @Column({ childType: RouteModelDetail })
  public routes!: RouteModelDetail[]
}
